import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { config } from "../../../config/config";
import { useLanguage } from "../../../i18n/useLanguage";
import { useDealerAccountInfo } from "../../../stores/hooks/useDealerAccountInfo";
import { OrderDetails } from "../../../stores/slices/cartSlice";
import { stripHTML } from "../../../util/stripHTML";

const darkOems = new Set(["bmw", "mazda", "mercedes"]);

export const CartPrintHeader: FunctionComponent<{
  isOrder: boolean;
  orderDetails: OrderDetails;
}> = ({ isOrder, orderDetails }) => {
  const { Logo, brandName } = config;
  const { t } = useTranslation();
  const [language] = useLanguage();
  const dealer = useDealerAccountInfo();
  return (
    <header className="grid grid-cols-2 gap-2">
      <div>
        <h1 className="text-3xl font-bold">
          {t(`cart.${isOrder ? "yourOrder" : "yourQuote"}`)} (#
          {orderDetails?.orderId})
        </h1>
        <h6>
          <strong className="font-semibold">
            {stripHTML(
              orderDetails.orderNotes[language] || orderDetails.orderNotes.en
            )}
            .
          </strong>{" "}
          <span className="font-ligth text-ink-2">
            {t("cart.thankYourForChoosing")} {dealer.dealerName}!
          </span>
        </h6>
      </div>
      <div className="flex justify-end items-center">
        <div
          className={clsx(
            "p-4",
            darkOems.has(brandName.toLowerCase()) &&
              "bg-black tw-print-color-adjust"
          )}
        >
          <Logo />
        </div>
      </div>
    </header>
  );
};
